/* eslint-disable no-restricted-globals */
import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import { GridSelectionModel } from '@mui/x-data-grid-pro'
import { BulkQr, Close, DownloadWhite, FastabLogoIcon } from 'assets/images'
import Button from 'components/Button/Index'
import ColorExtractorComponent from 'components/QRCodeDialog/ColorExtractorComponent'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'
import React, { useEffect, useState } from 'react'
// import OwlCarousel from 'react-owl-carousel'
import { toast } from 'react-toastify'
import qrService from 'services/qr.service'
import {
  QR_CODE_PORTRAIT_STICKER,
  QR_CODE_STICKER,
  QR_CODE_TENT,
} from 'utility/constants'

interface dialogProps {
  open: boolean
  onClose?: React.MouseEventHandler<Element>
  selectedTables: GridSelectionModel
  handleClose: (event: boolean) => void
  establishmentId: number
  restaurantLogo: string
}

function BulkQrCodeDialog(props: dialogProps) {
  const {
    open,
    onClose,
    selectedTables,
    handleClose,
    establishmentId,
    restaurantLogo,
  } = props
  const [byteArray, setByteArray] = useState('')

  const [dominantColor, setDominantColor] = useState(null)
  const [secondaryColor, setSecondaryColor] = useState(null)

  const handleDominantColorChange = (color) => {
    setDominantColor(color)
  }

  const handleSecondaryColorChange = (color) => {
    setSecondaryColor(color)
  }

  useEffect(() => {
    if (byteArray !== '') {
      const linkSource = `data:application/zip;base64,${byteArray}`
      const downloadLink = document.createElement('a')
      const fileName = `QR_Codes.zip`

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
      setByteArray('')
    }
  }, [byteArray])
  const downloadQRImage = (pdfByteArray, id) => {
    if (pdfByteArray !== '') {
      let downloadType
      if (id === QR_CODE_STICKER) {
        downloadType = 'Sticker'
      } else if (id === QR_CODE_PORTRAIT_STICKER) {
        downloadType = 'Portrait_Sticker'
      } else {
        downloadType = 'Tent'
      }
      const linkSource = `data:application/pdf;base64,${pdfByteArray}`
      const downloadLink = document.createElement('a')
      const fileName = `QR_Type_${downloadType}.pdf`

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    }
  }
  const handleBulkPdfDownload = async (e: number) => {
    if (selectedTables.length === 0) {
      toast.error('Please select QR Code(s) to download.')
      handleClose(false)
    } else {
      const pdfByteArray = await qrService.getBulkQrCodes({
        template: e,
        tableIds: selectedTables.map((d) => Number(d)),
        tableId: 0,
        scanToColorCode: dominantColor,
        payTabColorCode: secondaryColor,
        establishmentId,
      })
      downloadQRImage(pdfByteArray.data.data, e)
    }
  }
  // const options = {
  //   margin: 30,
  //   responsiveClass: true,
  //   nav: true,
  //   autoplay: false,
  //   navText: [
  //     `<img src=${UsermenuDownarrow} alt='Download' />`,
  //     `<img src=${UsermenuDownarrow} alt='Download' />`,
  //   ],
  //   smartSpeed: 1000,
  //   loop: true,
  //   responsive: {
  //     0: {
  //       items: 1,
  //     },
  //     400: {
  //       items: 1,
  //     },
  //     600: {
  //       items: 2,
  //     },
  //     700: {
  //       items: 2,
  //     },
  //     1000: {
  //       items: 2,
  //     },
  //   },
  // }

  return (
    <>
      <Dialog
        className="primary-dialog barcode-dialog"
        maxWidth="xl"
        fullWidth
        open={open}
        onClose={onClose}
      >
        <DialogTitle>
          <h5 className="bold">QR Code</h5>
          <Button
            variant="text"
            title="Close"
            onClick={onClose}
            className="icon-btn rounded"
            color="inherit"
          >
            <img src={Close} alt="Close" />
          </Button>
        </DialogTitle>
        <ColorExtractorComponent
          imageUrl={restaurantLogo}
          onDominantColorChange={handleDominantColorChange}
          onSecondaryColorChange={handleSecondaryColorChange}
        />
        {/* dialog-content start */}
        <DialogContent>
          {/* barcode-template start */}
          {/* <OwlCarousel className="slider-items owl-carousel" {...options}> */}
          <div className="barcode-template one">
            <p>Table Tent</p>
            <div
              id="targetDownload1"
              style={{
                backgroundColor: 'white',
              }}
            >
              <div className="card">
                <strong style={{ color: dominantColor }}>
                  <span style={{ display: 'block', color: dominantColor }}>
                    Scan To
                  </span>
                  <span style={{ color: secondaryColor }}>Pay Tab</span>
                </strong>
                <span>Here</span>
                <img
                  src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyOSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI5IDBMMTQuNDk5OSA5LjUwMDhMMCAwVjkuNTAwOEwxNC40OTk5IDE5TDI5IDkuNTAwOFYwWiIgZmlsbD0iIzcxQjZFNCIvPgo8L3N2Zz4K"
                  alt="Arrow Down"
                />
                <img
                  src={BulkQr}
                  alt="Bar Code "
                  style={{
                    height: '2in',
                    width: '2in',
                    display: 'block',
                    marginBottom: '0.18in',
                  }}
                />

                <div className="qr-code-restaurant-logo">
                  <img src={restaurantLogo} alt="FasTab" height="50px" />
                </div>
              </div>
            </div>
            <Button
              color="primary"
              title="Download"
              variant="contained"
              onClick={() => handleBulkPdfDownload(QR_CODE_TENT)}
            >
              <img src={DownloadWhite} alt="Download" />
              <span>Download</span>
            </Button>
          </div>
          {/* barcode-template end */}
          {/* barcode-template start */}
          <div className="barcode-template two">
            <p>Sticker</p>
            <div
              className="outer"
              id="targetDownload2"
              style={{
                backgroundColor: 'white',
              }}
            >
              <div className="card">
                <strong className="top">
                  <span style={{ display: 'block', color: dominantColor }}>
                    Scan To
                  </span>{' '}
                  <span style={{ color: secondaryColor }}>Pay Tab</span>
                </strong>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div
                    style={{
                      transform: 'rotate(90deg)',
                      fontSize: '14px',
                      lineHeight: '21px',
                      color: '#231f20',
                      fontWeight: '500',
                      textAlign: 'center',
                    }}
                  >
                    <img
                      src={restaurantLogo}
                      alt=""
                      style={{ height: 'auto', maxWidth: '100px' }}
                    />
                  </div>
                  <img
                    src={BulkQr}
                    alt=""
                    style={{
                      height: '2in',
                      width: '2in',
                      display: 'block',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                      marginBottom: '0.18in !important',
                    }}
                  />
                  <div
                    style={{
                      transform: 'rotate(90deg)',
                      fontSize: '14px',
                      lineHeight: '21px',
                      color: '#231f20',
                      fontWeight: '500',
                      textAlign: 'center',
                    }}
                  >
                    <img
                      src={restaurantLogo}
                      alt=""
                      style={{
                        height: 'auto',
                        maxWidth: '100px',
                        rotate: '180deg',
                      }}
                    />
                  </div>
                </div>

                <strong className="bottom">
                  <span style={{ display: 'block', color: dominantColor }}>
                    Scan To
                  </span>{' '}
                  <span style={{ color: secondaryColor }}>Pay Tab</span>
                </strong>
                {/* <div className="powered-by-text-left">
                  <small className="table-number" />
                  <div className="powered-by-text">
                    <small>Powered By FasTab</small>
                    <img
                      src="data:image/svg+xml;base64,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"
                      alt="FasTab"
                    />
                  </div>
                </div>
                <div className="powered-by-text-right">
                  <small className="table-number" />
                  <div className="powered-by-text">
                    <small>Powered By FasTab</small>
                    <img
                      src="data:image/svg+xml;base64,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"
                      alt="FasTab"
                    />
                  </div>
                </div> */}
              </div>
            </div>
            <Button
              color="primary"
              title="Download"
              variant="contained"
              onClick={() => handleBulkPdfDownload(QR_CODE_STICKER)}
            >
              <img src={DownloadWhite} alt="Download" />
              <span>Download</span>
            </Button>
          </div>
          <div className="barcode-template three">
            <p>Portrait Sticker</p>
            <div
              className="outer"
              id="targetDownload3"
              style={{
                backgroundColor: 'white',
              }}
            >
              <div className="powered-by-text-top">
                <div className="">
                  <img src={restaurantLogo} alt="" />
                </div>
                <small>
                  Powered By{' '}
                  <img src={FastabLogoIcon} height="14px" alt="fastab logo" />{' '}
                  FasTab
                </small>
              </div>
              <div className="card">
                <strong className="top">
                  <span style={{ display: 'block', color: dominantColor }}>
                    Scan To
                  </span>
                  <span style={{ color: secondaryColor }}>Pay Tab</span>
                </strong>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <img
                    src={BulkQr}
                    alt=""
                    style={{
                      height: '2in',
                      width: '2in',
                      display: 'block',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                      marginBottom: '0.18in !important',
                    }}
                  />
                </div>

                <strong className="bottom">
                  {dominantColor && (
                    <span style={{ display: 'block', color: dominantColor }}>
                      Scan To
                    </span>
                  )}
                  {secondaryColor && (
                    <span style={{ color: secondaryColor }}>Pay Tab</span>
                  )}
                </strong>
              </div>
              <div className="powered-by-text-bottom">
                <div className="">
                  <img src={restaurantLogo} alt="" style={{ height: '50px' }} />
                </div>
                <small>
                  Powered By{' '}
                  <img src={FastabLogoIcon} height="14px" alt="fastab logo" />{' '}
                  FasTab
                </small>
              </div>
            </div>
            <Button
              color="primary"
              title="Download"
              variant="contained"
              onClick={() => handleBulkPdfDownload(QR_CODE_PORTRAIT_STICKER)}
            >
              <img src={DownloadWhite} alt="Download" />
              <span>Download</span>
            </Button>
          </div>
          {/* barcode-template end */}
          {/* <div className="barcode-template one">
            <p>Skinny Table Tent</p>
            <div
              style={{
                height: '585px',
                width: '390px',
                display: 'flex',
                margin: '0 auto',
                position: 'relative',
                background: '#ffffff',
                textAlign: 'center',
                flexDirection: 'column',
                justifyContent: 'space-between',
                padding: '7px 28px',
                boxSizing: 'border-box',
                fontFamily: 'poppins',
                border: '1px solid #dde3ec',
                marginBottom: '30px',
              }}
            >
              <div style={{ transform: 'rotate(180deg)' }}>
                <h1
                  style={{
                    fontSize: '20px',
                    lineHeight: '26px',
                    marginBottom: '55px',
                    fontWeight: '700',
                    textAlign: 'center',
                    color: dominantColor,
                  }}
                >
                  Scan To
                  <span style={{ fontWeight: '700', color: secondaryColor }}>
                    Pay Tab
                  </span>
                </h1>
                <p
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '10px',
                    lineHeight: '16px',
                  }}
                >
                  Powered By FasTab
                  <img
                    src="data:image/svg+xml;base64,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"
                    alt=""
                    style={{
                      marginLeft: '6px',
                      display: 'block',
                      width: '30px',
                      fontSize: '10px',
                      lineHeight: '16px',
                    }}
                  />
                </p>
              </div>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <img
                  src={BulkQr}
                  alt="Barcode"
                  style={{
                    height: '2in',
                    width: '2in',
                    display: 'block',
                    marginBottom: '0.18in',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                />
              </div>

              <div>
                <h1
                  style={{
                    fontSize: '20px',
                    lineHeight: '26px',
                    marginBottom: '55px',
                    fontWeight: '700',
                    textAlign: 'center',
                    color: dominantColor,
                  }}
                >
                  Scan To
                  <span style={{ fontWeight: '700', color: secondaryColor }}>
                    Pay Tab
                  </span>
                </h1>
                <p
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '11px',
                    lineHeight: '16px',
                    color: '#383435',
                    fontWeight: '500',
                  }}
                >
                  Powered By FasTab
                  <img
                    src="data:image/svg+xml;base64,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"
                    alt=""
                    style={{
                      marginLeft: '6px',
                      display: 'block',
                      width: '30px',
                      fontSize: '10px',
                      lineHeight: '16px',
                    }}
                  />
                </p>
              </div>
            </div>
            <Button
              color="primary"
              title="Download"
              variant="contained"
              onClick={() => handleBulkPdfDownload(NEW_QR_CODE_TENT)}
            >
              <img src={DownloadWhite} alt="Download" />
              <span>Download</span>
            </Button>
          </div> */}
          {/* </OwlCarousel> */}
        </DialogContent>
        {/* dialog-content end */}
      </Dialog>
    </>
  )
}
export default BulkQrCodeDialog
